import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import { fetchGating } from "actions/gating";

export const useGating = (gatingConfigurations = [], pageLoaded = false) => {
  const gatingRef = useRef(null);
  const dispatch = useDispatch();
  const gatings = useSelector((state) => get(state, "gatings.gating", []));

  const handleMessage = (e) => {
    switch (e.data.type) {
      case "cleverstory:gating:preview": {
        const configuration = get(e, "data.payload.configuration", null);
        if (configuration) {
          gatingRef.current.triggerGating("PREVIEW", null, configuration);
        }
        break;
      }
      case "cleverstory:gating:closed": {
        const configuration = get(e, "data.payload.configuration", null);
        const switchGating = get(e, "data.payload.switchGating", false);
        gatingRef.current.closeGating(configuration, switchGating);
        break;
      }
    }
  };

  const handleResetGating = (_, switchGating) => {
    window.parent.postMessage(
      {
        type: "cleverstory:gating:closed",
        payload: { switchGating },
      },
      "*"
    );
  };

  useEffect(() => {
    if (!gatingConfigurations?.length) return;

    gatingConfigurations.forEach((item) => {
      const gatingId = get(item, "gating.id", null);
      if (!gatings?.[gatingId]) {
        dispatch(fetchGating(gatingId, true));
      }
    });

    window.parent.postMessage(
      {
        type: "cleverstory:gating:configs",
        payload: {
          gatingConfigs: gatingConfigurations,
          loading: !pageLoaded,
        },
      },
      "*"
    );
  }, [gatingConfigurations, gatings, pageLoaded, dispatch]);

  useEffect(() => {
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return { gatingRef, handleResetGating };
};
